<template>
    <b-card header="Diseñador de etiquetas" no-body class="mb-3">
        <b-tabs>

            <!-- Histórico de diseños -->
            <b-tab :active="activeTab === 1" @click="setActiveTab(1)">

                <template #title>
                    <strong><i class="fa fa-table text-info"></i> Histórico de diseños</strong>
                    <b-badge variant="primary" class="ml-2">{{ getQuantityDesigns }}</b-badge>
                </template>

                <History />

            </b-tab>

            <!-- Diseñador -->
            <b-tab :active="activeTab === 2" @click="setActiveTab(2)">

                <template #title>
                    <strong>🎨 Diseñador</strong>
                    <b-badge variant="info" class="ml-2 text-white"><i class="fa fa-star"></i> nuevo</b-badge>
                </template>

                <b-row class="m-0 p-0">
                    <DesignerPlane />
                </b-row>

            </b-tab>

        </b-tabs>
    </b-card>
</template>

<script>

// Generales
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

// Componentes
import { GridLayout, GridItem } from "vue-grid-layout"
import History from './History.vue';
import DesignerPlane from './DesignerPlane.vue';

export default {

    components: {
        DesignerPlane,
        History,
        GridLayout,
        GridItem
    },

    computed: {

        ...mapState('labelDesigner', [
            'selectedLayout',
            'activeSection',
            'activeTab',
            'generalDesigns',
            'filterHistory'
        ]),

        ...mapGetters('labelDesigner', [
            'layoutWithCm'
        ]),

        getQuantityDesigns() {
            return this.generalDesigns.length + this.filterHistory.designs.length
        }

    },

    async mounted() {   
        let payload = { type: 'GENERAL' }
        await this.getLabelDesigns(payload);
        
        await this.getAllSectionsGroupedByCategory();
    },

    methods: {

        ...mapMutations('labelDesigner', [
            'setSelectedLayout',
            'setActiveSection',
            'setActiveTab',
            'resetSelectedLayout'
        ]),

        ...mapActions('labelDesigner', {
            getLabelDesigns: 'getLabelDesigns',
            getAllSectionsGroupedByCategory: 'getAllSectionsGroupedByCategory'
        })

    }
};
</script>

<style scoped></style>
